import React from 'react';
import { Flex, Text, Box, useColorModeValue } from '@chakra-ui/react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const TruckLoader = () => {
  const textColor = useColorModeValue('gray.500', 'gray.400');

  return (
    <Flex 
      justify="center" 
      align="center" 
      h="60vh" 
      direction="column"
    >
      <Box w="300px" h="300px"> 
        <DotLottieReact
          src="/truck.lottie"
          loop
          autoplay
          style={{ width: '100%', height: '100%' }}
        />
      </Box>
    </Flex>
  );
};

export default TruckLoader;